var render = function render(){var _vm=this,_c=_vm._self._c;return _c('div',[_c('div',[_vm._v(_vm._s(_vm.item.value))]),_vm._v(" "),_c('div',{staticClass:"small"},[_vm._v("\n\t\t"+_vm._s(_vm.item.data.address.value)+"\n\t")])])
}
var staticRenderFns = []

export { render, staticRenderFns }